export default __webpack_public_path__ + "static/media/syslogyx.bbf92b48.png";